import React, { Component } from 'react'
import axios from 'axios';
import { Widget, addResponseMessage } from 'react-chat-widget';
import logo from './../logo.svg';
import 'react-chat-widget/lib/styles.css';
import ls from 'local-storage'

export class Chat extends Component {
    componentDidMount() {
        document.title = "Chatting" 
        addResponseMessage("Welcome to this awesome chat!");                
      }
    
      handleNewUserMessage = (newMessage) => {
        console.log(`New message incomig! ${newMessage}`);
        // Now send the message throught the backend API
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          const data ={'msg':newMessage}
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;   
          Axios.post(`${process.env.REACT_APP_API_URL}chatting`,data)
        .then(result=>{
          if(result.status === 200 && result.data.status === 200 ){
            addResponseMessage(result.data.msg); 
          }      
        });        
        
      }

    render() {
        return (
            <Widget
            handleNewUserMessage={this.handleNewUserMessage}
            profileAvatar={logo}
            title="My new awesome title"
            subtitle="And my cool subtitle"
          />
        )
    }
}

export default Chat
